(function () {
  var DESKTOP_QUERY = window.matchMedia('(min-width: 990px)');

  function getScrollContainer() {
    if (DESKTOP_QUERY.matches) {
      return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
    }
    return document.scrollingElement || document.documentElement;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#shopify-section-main"]');
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    getScrollContainer().scrollTo({ top: 0, behavior: 'smooth' });
  }, true);
})();
